import { useEffect } from "react";
import { Star } from "lucide-react";

const ELFSIGHT_SCRIPT_SRC = "https://elfsightcdn.com/platform.js";
const ELFSIGHT_APP_CLASS = "elfsight-app-c87b40c1-a0e7-4f89-b069-0088eeb09fef";

export default function Testimonials() {
  useEffect(() => {
    if (document.querySelector(`script[src="${ELFSIGHT_SCRIPT_SRC}"]`)) return;
    const script = document.createElement("script");
    script.src = ELFSIGHT_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-20 sm:py-28 lg:py-32 bg-slate-50/70"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-blue-800 mb-4">
            <Star size={14} strokeWidth={2} className="text-blue-800 fill-blue-800" />
            Real Client Reviews
          </div>
          <h2
            data-testid="testimonials-heading"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 leading-[1.1]"
          >
            What clients say after RAPID.
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            Live reviews from real KneadRelief clients, pulled directly from Google.
            Read what people in pain experience after their first session.
          </p>
        </div>

        <div className="mt-12">
          <div
            className={ELFSIGHT_APP_CLASS}
            data-elfsight-app-lazy
            data-testid="elfsight-google-reviews"
          />
        </div>
      </div>
    </section>
  );
}
